import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";
import dayjs from "dayjs";
const DynamicService = {
  // Existing login function
  getAllContact: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllContact +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllUsersWithoutPagination: async () => {
    try {
      const response = await axios.get(
        ApiConstants.getAllUsersWithoutPagination,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllCoordinatorWithoutPagination: async () => {
    try {
      const response = await axios.get(
        ApiConstants.getAllCoordinatorWithoutPagination,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllBharatSatPackagesWithoutPagination: async () => {
    try {
      const response = await axios.get(
        ApiConstants.getAllBharatSatPackagesWithoutPagination,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllStudentPackagePurchasedWithoutPagination: async () => {
    try {
      const response = await axios.get(
        ApiConstants.getAllStudentPackagePurchasedWithoutPagination,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  deleteContact: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteContact,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllCoordinator: async (offset, limit, searchQuery,searchDistrict, searchTaluka, startDate, endDate) => {
    try {
      const queryParams = new URLSearchParams({

        offset: offset,
        limit: limit,
        searchQuery: searchQuery,
        searchDistrict:searchDistrict,
        searchTaluka:searchTaluka,
        // selectedRegisterBy: selectedRegisterBy,
        // selectedPackageByFilter:selectedPackageByFilter,
      });
      if (startDate) {
        queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
      } else {
        queryParams.append('startDate', "");
      }
      if (endDate) {
        queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
      } else if (startDate && !endDate) {
        queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
      } else {
        queryParams.append('endDate', "");
      }
      const url = `${ApiConstants.getAllCoordinator}?${queryParams.toString()}`;
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  deleteCoordinator: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteCoordinator,
        {
          id:id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllRegistrUsers: async (offset, limit, searchQuery,searchDistrict, searchTaluka,selectedRegisterBy, startDate, endDate) => {
    try {
      const queryParams = new URLSearchParams({

        offset: offset,
        limit: limit,
        searchQuery: searchQuery,
        searchDistrict:searchDistrict,
        searchTaluka:searchTaluka,
        selectedRegisterBy: selectedRegisterBy,
      });

      if (startDate) {
        queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
      } else {
        queryParams.append('startDate', "");
      }
      if (endDate) {
        queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
      } else if (startDate && !endDate) {
        queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
      } else {
        queryParams.append('endDate', "");
      }
      const url = `${ApiConstants.getAllRegistration}?${queryParams.toString()}`;
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllBharasetExam: async (offset, limit, searchQuery,searchDistrict,searchTaluka,startDate,endDate) => {
    try {

      const queryParams = new URLSearchParams({

        offset: offset,
        limit: limit,
        searchQuery: searchQuery,
        searchDistrict:searchDistrict,
        searchTaluka:searchTaluka,
      });

      if (startDate) {
        queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
      } else {
        queryParams.append('startDate', "");
      }
      if (endDate) {
        queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
      } else if (startDate && !endDate) {
        queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
      } else {
        queryParams.append('endDate', "");
      }

      const url = `${ApiConstants.getAllBharasetExam}?${queryParams.toString()}`;
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllPurchasePackage: async (offset, limit, searchQuery,searchPackage,searchDistrict,searchTaluka,startDate,endDate) => {
    try {
      const queryParams = new URLSearchParams({

        offset: offset,
        limit: limit,
        searchQuery: searchQuery,
        searchPackage:searchPackage,
        searchDistrict:searchDistrict,
        searchTaluka:searchTaluka,
      });

      if (startDate) {
        queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
      } else {
        queryParams.append('startDate', "");
      }
      if (endDate) {
        queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
      } else if (startDate && !endDate) {
        queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
      } else {
        queryParams.append('endDate', "");
      }

      const url = `${ApiConstants.getAllPackagePurchased}?${queryParams.toString()}`;
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },


  deleteUser: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deletUser,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  addPrivacyPolicy: async (title, details) => {
    try {
      const response = await axios.post(
        ApiConstants.addPrivacyPolicy,
        { title: title, details: details },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  addTermsandConditions: async (title, details) => {
    try {
      const response = await axios.post(
        ApiConstants.addTermsandConditions,
        { title: title, details: details },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  addCancellationPolicyData: async (title, details) => {
    try {
      const response = await axios.post(
        ApiConstants.addCancellationPolicy,
        { title: title, details: details },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getPrivacyPolicy: async () => {
    try {
      const response = await axios.get(ApiConstants.getPrivacyPolicy);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getTermsConditions: async () => {
    try {
      const response = await axios.get(ApiConstants.getTermsConditions);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getCancellationPolicy: async () => {
    try {
      const response = await axios.get(ApiConstants.getCancellationPolicy);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAboutUsPageContent: async () => {
    try {
      const response = await axios.get(ApiConstants.getAboutUsPageContent);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  addAboutUsData: async ({
    cardOneTitle,
    cardOneDescription,
    cardTwoTitle,
    cardTwoDescription,
    cardThreeTitle,
    cardThreeDescription,
    cardFourTitle,
    cardFourDescription,
  }) => {
    try {
      const response = await axios.post(
        ApiConstants.addAboutUs,
        {
          cardOneTitle: cardOneTitle,
          cardOneDescription: cardOneDescription,
          cardTwoTitle: cardTwoTitle,
          cardTwoDescription: cardTwoDescription,
          cardThreeTitle: cardThreeTitle,
          cardThreeDescription: cardThreeDescription,
          cardFourTitle: cardFourTitle,
          cardFourDescription: cardFourDescription,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getSocialContactInfo: async () => {
    try {
      const response = await axios.get(ApiConstants.getSocialContactInfo);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  updateSocialContactInfo: async ({
    facebook,
    instagram,
    linkedin,
    twitter,
    youtube,
    phone,
    email,
    day,
    time,
  }) => {
    try {
      const response = await axios.post(
        ApiConstants.updateSocialContactInfo,
        {
          facebook: facebook,
          instagram: instagram,
          linkedin: linkedin,
          twitter: twitter,
          youtube: youtube,
          phone: phone,
          email: email,
          day: day,
          time: time,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};
export default DynamicService;
